import Vue from 'vue'
import App from './App.vue'
import theme from '@/assets/sass/style.scss'
import router from "@/router";
import store from './store';
import Vue2TouchEvents from 'vue2-touch-events'
import VueGtag from 'vue-gtag'
import PureSwipe from 'pure-swipe'
import './filters'
import VueMatomo from 'vue-matomo'
import settings from './settings'

window._paq = window._paq || [];

Vue.use(Vue2TouchEvents)
Vue.config.productionTip = false
Vue.use(PureSwipe)
Vue.use(VueGtag, {
  config: {
    id: 'G-5LF8GYWBH1',
    customMap: {
      'dimension0': 'company_name'
    }
  },
  pageTrackerTemplate() {
    return {
      company_name: store.getters.company.name
    }
  },
}, router)
if (settings.ENV === 'PRODUCTION') {
  Vue.use(VueMatomo, {
    host: 'https://analytics.macs.capgemini.com/',
    siteId: 6,
    router: router,
    enableLinkTracking: true,
  })
}

Object.defineProperty(String.prototype, 'capitalize', {
  value: function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  enumerable: false
});

Vue.use(theme)
new Vue({
  render: h => h(App),
  store: store,
  router: router
}).$mount('#app')
